import * as Sentry from '@sentry/react';
import {
  Modal,
  ModalActions,
  ModalContent,
  Prose,
  Pushbutton
} from '@stratumn/atomic';
import to from 'await-to-js';
import { removeTeamBot } from 'mutations';
import PropType from 'prop-types';
import { useState } from 'react';
import { SpanType, withSpanAsync } from 'tracing';
import { withGqlClient } from 'wrappers';

export const RemoveTeamBotModal = ({ environment, bot, team, toggleModal }) => {
  const [submitted, setSubmit] = useState(false);

  const removeBotGp = () => {
    withSpanAsync('removeTeamBot', SpanType.processing, async () => {
      setSubmit(true);

      const [err] = await to(
        removeTeamBot(environment, bot.id, bot.rowId, team.id, team.rowId)
      );

      if (err) {
        Sentry.captureException(err);
        setSubmit(false);
      } else {
        toggleModal();
      }

      return {};
    });
  };

  return (
    <Modal
      closeButtonLabel="Cancel"
      handleCollapse={toggleModal}
      title="Remove from Team"
    >
      <ModalContent>
        <Prose
          light
          text={`This action will remove **${bot.name}** from the **${
            team.name
          }** Team`}
        />
      </ModalContent>
      <ModalActions>
        <Pushbutton data-testid="cancel-button" onClick={toggleModal}>
          cancel
        </Pushbutton>
        <Pushbutton
          data-testid="remove-button"
          disabled={submitted}
          onClick={removeBotGp}
          warning
        >
          Remove from team
        </Pushbutton>
      </ModalActions>
    </Modal>
  );
};

RemoveTeamBotModal.propTypes = {
  environment: PropType.object.isRequired,
  bot: PropType.object.isRequired,
  team: PropType.object.isRequired,
  toggleModal: PropType.func.isRequired
};

export default withGqlClient(RemoveTeamBotModal);
